import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/template/Layout'
import store from '../store'

//component: () => import('@/views/Layout2'),

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/login',
            component: () => import('@/views/Login')
        },
        {
            path: '',
            component: Layout,
            redirect: '/dashboard',
            children: [
                {
                    path: '/dashboard',
                    component: () => import('@/views/Dashboard'),
                    name: 'Dashboard',
                    meta: { requiresLogin: true, title: 'dashboard', icon: 'dashboard', noCache: true, admin: false }
                },

                // USER ROUTE
                {
                    path: '/users',
                    component: () => import('@/views/modules/Users/list'),
                    name: 'userList',
                    meta: { requiresLogin: true, title: 'user', icon: 'user', noCache: true, admin: true },
                },
                {
                    path: '/users/:id?/:action/',
                    component: () => import('@/views/modules/Users/form'),
                    name: 'userForm',
                    meta: { requiresLogin: true, title: 'user', icon: 'user', noCache: true, admin: true },
                },

                // PROJECT ROUTE
                {
                    path: '/projects',
                    component: () => import('@/views/modules/Projects/list'),
                    name: 'projectList',
                    meta: { requiresLogin: true, title: 'project', icon: 'project', noCache: true, admin: false },
                },
                {
                    path: '/projects/:id?/:action/',
                    component: () => import('@/views/modules/Projects/form'),
                    name: 'projectForm',
                    meta: { requiresLogin: true, title: 'project', icon: 'project', noCache: true, admin: false },
                },

                // SCRIPT TYPE ROUTE
                {
                    path: '/scripttypes',
                    component: () => import('@/views/modules/ScriptType/list'),
                    name: 'scriptTypeList',
                    meta: { requiresLogin: true, title: 'scriptType', icon: 'scriptType', noCache: true, admin: true },
                },
                {
                    path: '/scripttypes/:id?/:action/',
                    component: () => import('@/views/modules/ScriptType/form'),
                    name: 'scriptTypeForm',
                    meta: { requiresLogin: true, title: 'scriptType', icon: 'scriptType', noCache: true, admin: true },
                },

                // LANGUAGES
                {
                    path: '/languages',
                    component: () => import('@/views/modules/Languages/list'),
                    name: 'languageList',
                    meta: { requiresLogin: true, title: 'language', icon: 'language', noCache: true, admin: true },
                },
                {
                    path: '/languages/:id?/:action/',
                    component: () => import('@/views/modules/Languages/form'),
                    name: 'languageForm',
                    meta: { requiresLogin: true, title: 'language', icon: 'language', noCache: true, admin: true },
                },

                // LIBRARY ROUTE
                {
                    path: '/libraries',
                    component: () => import('@/views/modules/Libraries/list'),
                    name: 'libraryList',
                    meta: { requiresLogin: true, title: 'library', icon: 'library', noCache: true, admin: true },
                },
                {
                    path: '/libraries/:id?/:action/',
                    component: () => import('@/views/modules/Libraries/form'),
                    name: 'libraryForm',
                    meta: { requiresLogin: true, title: 'library', icon: 'library', noCache: true, admin: true },
                },

                //TRANSLATIONS
                {
                    path: '/translations',
                    component: () => import('@/views/modules/Translations/form'),
                    name: 'translationForm',
                    meta: { requiresLogin: true, title: 'translation', icon: 'translation', noCache: true, admin: true },
                },
                //SETTINGS
                {
                    path: '/settings',
                    component: () => import('@/views/modules/Settings/form'),
                    name: 'settingForm',
                    meta: { requiresLogin: true, title: 'setting', icon: 'setting', noCache: true, admin: true },
                },




            ]
        },
        { path: '*', component: () => import('@/views/Dashboard'), }
    ]
});



router.beforeEach((to, from, next) => {

    let expiration = window.localStorage.getItem('tokenExpiration')
    var unixTimestamp = new Date().getTime() / 1000

    if (!(expiration !== null && parseInt(expiration) - unixTimestamp > 0)) {
        store.dispatch('logout').then(() => {})
    }



    if (to.matched.some(record => record.meta.requiresLogin)) {
        if (!store.getters.isAuthenticated) {
            next({
                path: '/login'
            })
        } else {
            if( to.meta.admin == true && window.localStorage.getItem('role_id') > 2 ) {
                next({
                    path: '/dashboard'
                })
            } else {
                next()
            }
        }
    } else {
        next()
    }
});

export default router